module.exports = __webpack_public_path__ + "static/media/Apple iPad Silver.e46a77db.png";